<template>
  <div class="container">
    <div class="row justify-content-center p-2 p-md-5">
      <div class="col-lg-7 col-md-10">
        <div class="card shadow border-0">
          <template v-if="!showThankYou">
          <div class="card-body px-lg-5 py-lg-5">
            <div class="text-center text-muted mb-4">
              <h3 class="pb-2">{{ $t("Registration Form") }}</h3>
              <p>{{ $t("Register now to easily request personalised home care services and healthcare support, delivered right to your door!") }}</p>
            </div>
            <!--          <div v-if="type == null">-->
            <!--            <div class="d-grid gap-2">-->
            <!--              <base-button type="primary" @click="type='employee'">{{ $t("Partners Portal") }}</base-button>-->
            <!--              <base-button type="primary" @click="type='client'">{{ $t("Organizations Portal") }}</base-button>-->
            <!--            </div>-->
            <!--          </div>-->
            <!--          <email-password v-if="['client', 'admin'].includes(type)"></email-password>-->
            <div class="ps-lg-4">
              <div class="row">
                <div class="col-md-6">
                  <base-input
                      v-model="model.firstName"
                      alternative=""
                      :label="$t('First name')"
                      :placeholder="$t('First name')"
                      input-classes="form-control-alternative"
                      :error="v$.model.firstName.$errors.map( err => { return err.$message })[0]"
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                      v-model="model.lastName"
                      alternative=""
                      :label="$t('Last name')"
                      :placeholder="$t('Last name')"
                      input-classes="form-control-alternative"
                      :error="v$.model.lastName.$errors.map( err => { return err.$message })[0]"
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                      v-model="model.identityCardNumber"
                      alternative=""
                      :label="$t('Identity card number')"
                      :placeholder="$t('Identity card number')"
                      input-classes="form-control-alternative"
                      :error="v$.model.identityCardNumber.$errors.map( err => { return err.$message })[0]"
                  />
                </div>
                <div class="col-md-6 text-start">
                  <div class="form-group has-label">
                  <label class="form-control-label ">{{ $t("Preferred language") }} </label>
                  <multiselect
                      v-model="model.contactLanguage"
                      :options="['en','el']"
                      :placeholder="$t('Select language')"
                      :show-labels="false"
                      required
                      class=""
                  >
                    <template #singleLabel="{ option }">{{ $t(option) }}</template>
                    <template #option="props">
                      {{ $t(props.option) }}
                    </template>
                  </multiselect>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="form-control-label float-start">{{ $t("Phone number") }}</label>
                    <base-input
                        v-model="model.phoneNumber"
                        type="number"
                        form-classes="input-group-alternative mb-3 phone-input"
                        style="display: flex;border-radius: 0;"
                        :placeholder="$t('Phone number')"
                        :error="v$.model.phoneNumber.$errors.map( err => { return err.$message })[0]"
                    >
                      <template #addonLeft>
                        <multiselect
                            v-model="model.phoneNumberCode"
                            :options="countryCodes"
                            placeholder=""
                            :show-labels="false"
                            required
                            :custom-label="customLabel"
                            :multiple="false"
                            class=""
                        >
                          <template #singleLabel="{ option }">
                            <img v-if="option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+option.iso.toUpperCase()+'.png')" />
                            <span class="ps-1" style="line-height: 31px">{{ option.code }}</span>
                          </template>
                          <template #option="props">
                            <img v-if="props.option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+props.option.iso.toUpperCase()+'.png')" />
                            {{ props.option.text }}
                          </template>
                        </multiselect>
                      </template>
                      <template #infoBlock>
                        <span class="row w-100 text-sm text-muted">
                          {{ $t("Phone number will be used for authentication when logging in to your account.") }}
                        </span>
                      </template>
                    </base-input>
                  </div>
                </div>
                <div v-if="!isUpdate" class="col-12">
                  <base-input
                      v-model="model.email"
                      alternative=""
                      label="Email address"
                      placeholder="Email address"
                      input-classes="form-control-alternative"
                      :error="v$.model.email.$errors.map( err => { return err.$message })[0]"
                      @keydown.space="(event) => event.preventDefault()"
                  >
                  </base-input>
                </div>
                <div class="col-md-12 text-start" :class="[{ 'has-danger': v$.model.termsAndConditions.$error }]">
                  <input v-model="model.termsAndConditions" class="form-check-input p-2" type="checkbox" value="false">
                  {{ $t("I agree to the") }} <a class="text-decoration-underline" target="_blank" :href="`/terms-and-conditions${$store.state.locale === 'el' ? '-gr' : ''}.html`">{{ $t("terms & conditions") }} <i class="fa fa-external-link"></i></a>
                  <div v-if="v$.model.termsAndConditions.$invalid" class="text-danger invalid-feedback"
                       style="display: block;"
                  >
                    {{ v$.model.termsAndConditions.$errors.map(err => {return err.$message})[0] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <base-button type="primary" :disabled="registerLoader" class="mt-4 mb-2" @click="submitRegistration()">
              <template v-if="registerLoader">
                <span class="fas fa-cog fa-spin" aria-hidden="true"></span>
              </template>
              <template v-else>
                {{ $t("Submit") }}
              </template>
            </base-button>
            <base-alert v-if="showAlert" :type="alertType">
              <strong></strong> {{ $t(alertMessage) }}
            </base-alert>
          </div>
          </template>
          <template v-else>
            <div class="card-body px-lg-5 py-lg-5">
              <i style="font-size: 50px" class="pb-4 fa fa-check-circle  text-success"></i>
                  <h3 class="card-title">{{ $t("Thank You for Registering!") }}</h3>
                  <p class="card-text mt-4">
                    {{ $t("Your registration was successful.") }}
                    {{ $t("You can now request home care services and healthcare support tailored to your needs.") }}
                  </p>
              <a class="btn btn-primary mt-3 fw-bold" href="/login">{{ $t("Login now") }}</a>
<!--                  <router-link to="/login#registration_complete" class="btn btn-primary mt-3 fw-bold">{{ $t("Login now") }}</router-link>-->
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import BaseInput from "@/components/BaseInput.vue"
import useVuelidate from "@vuelidate/core"
import {isoCountryCodeToFlagEmoji, isWindows} from "@/helpers/common"
import {email, helpers, minLength, required, sameAs} from "@vuelidate/validators"
import { getCountryCallingCode, isValidNumber} from "libphonenumber-js"
import BaseButton from "@/components/BaseButton.vue"
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import BaseAlert from "@/components/BaseAlert.vue"
const isValidPhone = (param) => helpers.withParams(
    { type: "isValidPhone", value: param }, (value) => {

      if (value == null || value === ""){
        return true
      }
      console.log("param+value", param+value)
      return isValidNumber(param+value)
    })
export default {
  name: "ClientRegistration",
  components: {BaseAlert, BaseButton, BaseInput},
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      showThankYou: false,
      registerLoader: false,
      showAlert: false,
      alertType: "",
      alertMessage: "",
      isWindows,
      countryCodes: [],
      isUpdate: false,
      errorMessage: "",
      loadingProcess: "",
      loadingMessage: "",
      cities: ["LIMASSOL", "NICOSIA", "LARNACA", "PAPHOS", "AMOCHOSTOS"],
      country: "Cyprus",
      model: {
        firstName: null,
        lastName: null,
        phoneNumber: null,
        phoneNumberCode: {code: "+357", text: this.$t("CY") + " +357", iso: "CY"},
        contactLanguage: "en",
        email: null,
        identityCardNumber: null,
        termsAndConditions: false,
      }
    }
  },
  validations () {
    return {
      model: {
        phoneNumber: {
          validated: helpers.withMessage(this.$t("Must be valid phone number."), isValidPhone(this.model.phoneNumberCode?.code)),
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        firstName: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        identityCardNumber: {
          required: helpers.withMessage(this.$t("Value is required"), required),
          minLength: minLength(6)
        },
        lastName: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        email: {
          email: email,
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        termsAndConditions: {
          sameAsRawValue: helpers.withMessage(this.$t("Please accept terms & conditions"), sameAs(true))
        }
      },
    }
  },
  mounted() {
    let countries = ["CY", "GB", "GR"] //getCountries()

    countries.forEach(country => {
      let code = getCountryCallingCode(country)
      this.countryCodes.push({code: "+" + code, text: this.$t(country) + " +" + code, iso: country})
    })
  },
  methods: {
    customLabel(option) {
      return `${option.text}`
    },
    isoCountryCodeToFlagEmoji,
    submitRegistration(){
      this.v$.$touch()

      if (this.v$.model.$invalid) {
        console.log(this.v$.$errors)
        return
      }
      this.loadingProcess = "processing"
      this.registerLoader = true

      const payload = JSON.parse(JSON.stringify(this.model))
      payload.phoneNumber = payload.phoneNumberCode.code+payload.phoneNumber
      delete payload.phoneNumberCode

      FirebaseFunctionsHelper.callFunction("client-register", payload).then((data) => {
        if (data === null) {
          this.initAlert("danger", "There was a problem with the request. Please contact us.")
        } else {
          this.registerLoader = false
         this.showThankYou = true

        }
      }).catch((error) => {
        this.registerLoader = false
        let message = error.message
        if (error.code === "functions/already-exists") {
          message = "The user already exists. Please try to login instead."
        }
        this.initAlert("danger", message)
      })
    },
    initAlert(type, message) {
      this.showAlert = true
      this.alertType = type
      this.alertMessage = message
    },
  }
}
</script>

<style scoped>

</style>